import MatchingLoad1 from 'components/elements/icons/MatchingLoad1'
import InformationContent from 'components/elements/items/InformationContent'
import RequestedTemplate from 'components/templates/RequestedTemplate'
import React from 'react'
import { QnStatesProps } from 'states/QnState'
import { StatesProps } from 'utils/commonHooks'

type MessageProps = {
  message: string
  large?: boolean
  small?: boolean
}

type InformationIconProps = {
  icon: React.ReactNode
  marginBottom?: string
}

/**
 * QN-08: 完了画面
 */
const Informed: React.FC<StatesProps> = (props: QnStatesProps) => {
  const { state } = props

  /** 完了画面に表示するコンテンツ  */
  const contentItems: Array<MessageProps | InformationIconProps> = [
    {
      message: 'ご要請を承りました。',
      large: true,
    },
    {
      message:
        '向かうスタッフが決まったらご連絡いたします。\n※追加でご案内・ご確認することがある場合は\nオペレーターからご連絡いたします。',
      small: true,
    },
    {
      icon: <MatchingLoad1 />,
      marginBottom: '15px',
    },
    {
      message: 'スタッフ到着まで安全な場所で\n画面を閉じてお待ちください。',
      small: true,
    },
  ]
  return (
    <RequestedTemplate
      title={'完了画面'}
      content={
        <InformationContent items={contentItems} contentHeight="400px" />
      }
      state={state}
    />
  )
}

export default Informed
